import Vue from 'vue'
const vue = new Vue()
const cloneDeep = require('lodash.clonedeep')
const mock = {
  users: [
    {
      id: '1',
      login: 'demo',
      roles: [
        'admin',
        'write',
      ],
      email: 'demo@domain.ltd',
      isActive: true,
    },
    {
      id: '2',
      login: 'demo-2',
      roles: [
        'write',
      ],
      email: 'admin@domain.ltd',
      isActive: true,
    },
  ],
  tokens: [
    {
      id: '1234',
      userId: '1',
      issuedDate: vue.$moment().subtract(1424, 'minutes').format(),
      userAgent: 'Mozilla/5.0 (Android 9; Mobile; rv:84.0) Gecko/84.0 Firefox/84.0',
      ip: '10.0.0.21',
      token: 'abcd1234-1234-1234-abcd-abcd1234abcd',
    },
    {
      id: '5678',
      userId: '1',
      issuedDate: vue.$moment().format(),
      userAgent: 'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:84.0) Gecko/20100101 Firefox/84.0',
      ip: '10.0.0.53',
      token: 'abcd1234-5678-5678-abcd-abcd5678abcd',
    },
  ],
  rooms: [
    {
      id: '1',
      name: 'Maison',
      parentId: null,
      isVisible: true,
      summary: [
        {
          key: 'temperature',
          value: 21.3,
        },
        {
          key: 'humidity',
          value: 41,
        },
        {
          key: 'download',
          value: 62,
        },
        {
          key: 'upload',
          value: 6,
        },
        {
          key: 'power',
          value: 1250,
        },
      ],
      summaryStates: [
        { state: '11', key: 'temperature' },
        { state: '16', key: 'temperature' },
        { state: '14', key: 'humidity' },
        { state: '15', key: 'humidity' },
        { state: '4', key: 'power' },
        { state: '200', key: 'download' },
        { state: '201', key: 'upload' },
      ],
    },
    {
      id: '2',
      name: 'Extérieur',
      parentId: '1',
      isVisible: true,
      summary: [
        {
          key: 'temperature',
          value: 12,
        },
        {
          key: 'humidity',
          value: 90,
        },
      ],
      summaryStates: [
        { state: '5', key: 'temperature' },
        { state: '6', key: 'humidity' },
      ],
    },
    {
      id: '3',
      name: 'Séjour',
      parentId: '1',
      isVisible: true,
      summary: [
        {
          key: 'temperature',
          value: 22,
        },
        {
          key: 'humidity',
          value: 41,
        },
      ],
      summaryStates: [
        { state: '16', key: 'temperature' },
        { state: '15', key: 'humidity' },
      ],
    },
    {
      id: '4',
      name: 'Chambre',
      parentId: '1',
      isVisible: true,
      summary: [
        {
          key: 'temperature',
          value: 21,
        },
        {
          key: 'humidity',
          value: 42,
        },
      ],
      summaryStates: [
        { state: '11', key: 'temperature' },
        { state: '14', key: 'humidity' },
      ],
    },
    {
      id: '5',
      name: 'Cuisine',
      parentId: '1',
      isVisible: true,
      summary: [
        {
          key: 'light',
          value: 0,
        },
      ],
      summaryStates: [
        { state: '170', key: 'light' },
      ],
    },
  ],
  equipments: [
    {
      id: '1',
      logicalId: 'domonode',
      roomId: '1',
      module: 'core',
      name: 'Domonode',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(2, 'days').format(),
      tags: [],
    },
    {
      id: '2',
      logicalId: 'conso',
      roomId: '1',
      module: 'enedis',
      name: 'Consommation électrique',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(30, 'seconds').format(),
      tags: [],
    },
    {
      id: '3',
      logicalId: '02:00:00:00:00:00',
      roomId: '2',
      module: 'netatmo',
      name: 'Météo (extérieure)',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(20, 'minutes').format(),
      battery: 46,
      hasLowBattery: false,
      hasNoCommunication: true,
      alertNoCommunicationDelay: 15,
      tags: [
        'Météo',
      ],
    },
    {
      id: '4',
      logicalId: '04:00:00:00:00:00:fa',
      roomId: '4',
      module: 'netatmo',
      name: 'Météo (Chambre)',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(5, 'minutes').format(),
      battery: 68,
      hasLowBattery: false,
      hasNoCommunication: null,
      alertNoCommunicationDelay: 15,
      tags: [
        'Météo',
      ],
    },
    {
      id: '5',
      logicalId: '05:00:00:04:c5:b8',
      roomId: '2',
      module: 'netatmo',
      name: 'Pluviomètre',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(5, 'minutes').format(),
      battery: 40,
      hasLowBattery: false,
      hasNoCommunication: null,
      alertNoCommunicationDelay: 15,
      tags: [
        'Météo',
      ],
    },
    {
      id: '6',
      logicalId: '06:00:00:00:00:00',
      roomId: '2',
      module: 'netatmo',
      name: 'Anémomètre',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(5, 'minutes').format(),
      battery: 62,
      hasLowBattery: false,
      hasNoCommunication: null,
      alertNoCommunicationDelay: 15,
      tags: [
        'Météo',
      ],
    },
    {
      id: '8',
      logicalId: '70:00:00:00:00:00',
      roomId: '3',
      module: 'netatmo',
      name: 'Météo (Salon)',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(5, 'minutes').format(),
      hasNoCommunication: null,
      alertNoCommunicationDelay: 15,
      tags: [
        'Météo',
      ],
    },
    {
      id: '9',
      logicalId: 'xmpp',
      roomId: '1',
      module: 'xmpp',
      name: 'XMPP',
      isVisible: false,
      isActive: true,
      lastCommunication: vue.$moment().subtract(3, 'day').format(),
      tags: [],
    },
    {
      id: '10',
      logicalId: 'box',
      roomId: '1',
      module: 'box',
      name: 'FAI box',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(3, 'minutes').format(),
      alertNoCommunicationDelay: 10,
      tags: [
        'Réseau',
      ],
    },
    {
      id: '23',
      logicalId: '10/4/181',
      roomId: '5',
      module: 'knx',
      name: 'Volet cuisine',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(1, 'day').format(),
      hasNoCommunication: null,
      tags: [
        'Volets',
      ],
    },
    {
      id: '29',
      logicalId: '10/4/224',
      roomId: '4',
      module: 'knx',
      name: 'Volet chambre',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(1, 'day').format(),
      hasNoCommunication: null,
      tags: [
        'Volets',
      ],
    },
    {
      id: '17',
      logicalId: '10/4/107',
      roomId: '5',
      module: 'knx',
      name: 'Plafonnier cuisine',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(1, 'day').format(),
      hasNoCommunication: null,
      tags: [],
    },
    {
      id: '20',
      logicalId: '24/4/25',
      roomId: '4',
      module: 'knx',
      name: 'Plafonnier chambre',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(1, 'day').format(),
      hasNoCommunication: null,
      tags: [],
    },
    {
      id: '101',
      logicalId: 'plafonnier-sejour',
      roomId: '3',
      module: 'knx',
      name: 'Plafonnier séjour',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(1, 'day').format(),
      hasNoCommunication: null,
      tags: [],
    },
    {
      id: '102',
      logicalId: 'volet-sejour',
      roomId: '3',
      module: 'knx',
      name: 'Volet séjour',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(4, 'hours').format(),
      hasNoCommunication: null,
      tags: [
        'Volets',
      ],
    },
    {
      id: '40',
      logicalId: '69000',
      roomId: '2',
      module: 'rain',
      name: 'Prévisions de pluie',
      isVisible: true,
      isActive: true,
      lastCommunication: vue.$moment().subtract(15, 'minutes').format(),
      hasNoCommunication: null,
      tags: [
        'Météo',
      ],
    },
  ],
  actions: [
    {
      id: '1',
      logicalId: 'log',
      name: 'Log',
      eqId: '1',
      module: 'core',
      type: 'button',
      isVisible: false,
      icon: 'far fa-edit',
    },
    {
      id: '2',
      logicalId: 'generic-update-state',
      name: 'Update state',
      eqId: '1',
      module: 'core',
      type: 'button',
      params: {
        stateId: '1',
        value: 'holidays',
      },
      paramsType: 'json',
      isVisible: false,
    },
    {
      id: '3',
      logicalId: 'update-state-holidays-off',
      name: 'Congés off',
      eqId: '1',
      module: 'core',
      type: 'switch_off',
      params: {
        stateId: '1',
        value: 0,
      },
      paramsType: 'json',
      isVisible: true,
      stateFeedbackId: '1',
    },
    {
      id: '4',
      logicalId: 'update-state-holidays-on',
      name: 'Congés on',
      eqId: '1',
      module: 'core',
      type: 'switch_on',
      params: {
        stateId: '1',
        value: 1,
      },
      paramsType: 'json',
      isVisible: true,
      stateFeedbackId: '1',
    },
    {
      id: '5',
      logicalId: 'demo@domain.ltd',
      name: 'Message à l\'utilisateur',
      eqId: '9',
      module: 'xmpp',
      type: 'button',
      params: 'Coucou',
      paramsType: 'string',
      options: [
        {
          value: "J'éteins la lumière ?",
          label: '',
        },
        {
          value: 'Je ferme les volets ?',
          label: '',
        },
      ],
      isVisible: false,
      isAsk: true,
      icon: 'fa fa-comment',
      stateFeedbackId: '17',
    },
    {
      id: '100',
      logicalId: '10/4/111',
      name: 'Intensité',
      eqId: '101',
      module: 'knx',
      type: 'slider',
      paramsType: 'json',
      params: { value: 0 },
      isVisible: true,
      stateFeedbackId: '100',
    },
    {
      id: '101',
      logicalId: '24/4/24',
      name: 'switch',
      eqId: '20',
      module: 'knx',
      type: 'switch',
      paramsType: 'json',
      params: { value: 1 },
      isVisible: true,
      stateFeedbackId: '101',
    },
    {
      id: '170',
      logicalId: '10/4/107',
      name: 'switch',
      eqId: '17',
      module: 'knx',
      type: 'switch',
      paramsType: 'json',
      params: { value: 1 },
      isVisible: true,
      stateFeedbackId: '170',
    },
    {
      id: '102',
      logicalId: '10/4/175',
      name: 'Montée',
      eqId: '102',
      module: 'knx',
      type: 'button',
      paramsType: 'json',
      params: { value: 1 },
      isVisible: true,
      icon: 'fas fa-angle-double-up',
    },
    {
      id: '103',
      logicalId: '10/4/176',
      name: 'Arrêt',
      eqId: '102',
      module: 'knx',
      type: 'button',
      paramsType: 'json',
      params: { value: 1 },
      isVisible: true,
      icon: 'fas fa-stop',
    },
    {
      id: '104',
      logicalId: '10/4/175',
      name: 'Descente',
      eqId: '102',
      module: 'knx',
      type: 'button',
      paramsType: 'json',
      params: { value: 0 },
      isVisible: true,
      icon: 'fas fa-angle-double-down',
    },
    {
      id: '105',
      logicalId: '10/4/224',
      name: 'Montée',
      eqId: '29',
      module: 'knx',
      type: 'button',
      paramsType: 'json',
      params: { value: 1 },
      isVisible: true,
      icon: 'fas fa-angle-double-up',
    },
    {
      id: '106',
      logicalId: '10/4/223',
      name: 'Arrêt',
      eqId: '29',
      module: 'knx',
      type: 'button',
      paramsType: 'json',
      params: { value: 1 },
      isVisible: true,
      icon: 'fas fa-stop',
    },
    {
      id: '107',
      logicalId: '10/4/224',
      name: 'Descente',
      eqId: '29',
      module: 'knx',
      type: 'button',
      paramsType: 'json',
      params: { value: 0 },
      isVisible: true,
      icon: 'fas fa-angle-double-down',
    },
    {
      id: '108',
      logicalId: '10/4/181',
      name: 'Montée',
      eqId: '23',
      module: 'knx',
      type: 'button',
      paramsType: 'json',
      params: { value: 1 },
      isVisible: true,
      icon: 'fas fa-angle-double-up',
    },
    {
      id: '109',
      logicalId: '10/4/180',
      name: 'Arrêt',
      eqId: '23',
      module: 'knx',
      type: 'button',
      paramsType: 'json',
      params: { value: 1 },
      isVisible: true,
      icon: 'fas fa-stop',
    },
    {
      id: '110',
      logicalId: '10/4/181',
      name: 'Descente',
      eqId: '23',
      module: 'knx',
      type: 'button',
      paramsType: 'json',
      params: { value: 0 },
      isVisible: true,
      icon: 'fas fa-angle-double-down',
    },
    {
      id: '200',
      logicalId: 'reboot',
      name: 'Reboot',
      eqId: '10',
      module: 'knx',
      type: 'button',
      paramsType: 'string',
      params: '',
      isVisible: true,
      needsConfirm: true,
      icon: 'fas fa-redo-alt',
    },
  ],
  states: [
    {
      id: '1',
      logicalId: 'mode',
      name: 'Mode congés',
      eqId: '1',
      module: 'core',
      type: 'boolean',
      currentValue: 0,
      isVisible: true,
      date: vue.$moment().subtract(2, 'days').format(),
      icon: 'fa fa-bed',
    }, {
      id: '4',
      logicalId: 'puissance-instantanee',
      name: 'Puissance',
      eqId: '2',
      module: 'enedis',
      type: 'numeric',
      currentValue: 1250,
      isVisible: true,
      icon: 'fa fa-bolt',
      isHistorized: true,
      date: vue.$moment().subtract(30, 'seconds').format(),
      unit: 'kW',
    },
    {
      id: '2',
      logicalId: '06:00:00:00:00:00#WindAngle',
      name: 'Direction',
      eqId: '6',
      module: 'netatmo',
      type: 'numeric',
      genericType: 'WIND_DIRECTION',
      isVisible: true,
      currentValue: 315,
      date: vue.$moment().subtract(5, 'minutes').format(),
      unit: '°',
    },
    {
      id: '3',
      logicalId: '06:00:00:00:00:00#WindStrength',
      name: 'Vitesse',
      eqId: '6',
      module: 'netatmo',
      type: 'numeric',
      genericType: 'WIND_SPEED',
      isHistorized: true,
      isVisible: true,
      currentValue: 1,
      date: vue.$moment().subtract(5, 'minutes').format(),
      unit: 'km/h',
    },
    {
      id: '5',
      logicalId: '02:00:00:00:00:00#Temperature',
      name: 'Temperature',
      eqId: '3',
      module: 'netatmo',
      type: 'numeric',
      genericType: 'TEMPERATURE',
      isHistorized: true,
      isVisible: true,
      currentValue: 12.8,
      date: vue.$moment().subtract(20, 'minutes').format(),
      unit: '°C',
    },
    {
      id: '6',
      logicalId: '02:00:00:00:00:00#Humidity',
      name: 'Humidité',
      eqId: '3',
      module: 'netatmo',
      type: 'numeric',
      genericType: 'HUMIDITY',
      isHistorized: true,
      isVisible: true,
      currentValue: 90,
      date: vue.$moment().subtract(20, 'minutes').format(),
      unit: '%',
    },
    {
      id: '7',
      logicalId: '70:00:00:00:00:00#CO2',
      name: 'CO2',
      eqId: '8',
      module: 'netatmo',
      type: 'numeric',
      genericType: 'CO2',
      isHistorized: true,
      isVisible: true,
      currentValue: 749,
      date: vue.$moment().subtract(5, 'minutes').format(),
      unit: 'ppm',
    },
    {
      id: '11',
      logicalId: '04:00:00:00:00:00:fa#Temperature',
      name: 'Temperature',
      eqId: '4',
      module: 'netatmo',
      type: 'numeric',
      genericType: 'TEMPERATURE',
      isHistorized: true,
      isVisible: true,
      currentValue: 20.6,
      date: vue.$moment().subtract(5, 'minutes').format(),
      unit: '°C',
    },
    {
      id: '12',
      logicalId: '05:00:00:04:c5:b8#sum_rain_1',
      name: 'Pluie',
      eqId: '5',
      module: 'netatmo',
      type: 'numeric',
      genericType: 'RAIN_SUM',
      isHistorized: true,
      isVisible: true,
      currentValue: 0.5,
      date: vue.$moment().subtract(5, 'minutes').format(),
      unit: 'mm/h',
      icon: 'fas fa-cloud-showers-heavy',
    },
    {
      id: '13',
      logicalId: '04:00:00:00:00:00:fa#CO2',
      name: 'CO2',
      eqId: '4',
      module: 'netatmo',
      type: 'numeric',
      genericType: 'CO2',
      isHistorized: true,
      isVisible: true,
      currentValue: 693,
      date: vue.$moment().subtract(5, 'minutes').format(),
      unit: 'ppm',
    },
    {
      id: '14',
      logicalId: '04:00:00:00:00:00:fa#Humidity',
      name: 'Humidité',
      eqId: '4',
      module: 'netatmo',
      type: 'numeric',
      genericType: 'HUMIDITY',
      isHistorized: true,
      isVisible: true,
      currentValue: 42,
      date: vue.$moment().subtract(5, 'minutes').format(),
      unit: '%',
    },
    {
      id: '15',
      logicalId: '70:00:00:00:00:00#Humidity',
      name: 'Humidité',
      eqId: '8',
      module: 'netatmo',
      type: 'numeric',
      genericType: 'HUMIDITY',
      isHistorized: true,
      isVisible: true,
      currentValue: 41,
      date: vue.$moment().subtract(5, 'minutes').format(),
      unit: '%',
    },
    {
      id: '16',
      logicalId: '70:00:00:00:00:00#Temperature',
      name: 'Temperature',
      eqId: '8',
      module: 'netatmo',
      type: 'numeric',
      genericType: 'TEMPERATURE',
      isHistorized: true,
      isVisible: true,
      currentValue: 22,
      date: vue.$moment().subtract(5, 'minutes').format(),
      unit: '°C',
    },
    {
      id: '17',
      logicalId: 'demo@domain.ltd',
      name: 'Message de l\'utilisateur',
      eqId: '9',
      module: 'xmpp',
      type: 'string',
      isVisible: false,
      currentValue: 'Hello',
      date: vue.$moment().subtract(3, 'day').format(),
    },
    {
      id: '81',
      logicalId: 'forecastDate',
      name: 'forecast date',
      eqId: '40',
      module: 'rain',
      isVisible: true,
      currentValue: vue.$moment().format(),
      date: vue.$moment().format(),
    },
    {
      id: '82',
      logicalId: 'prev0',
      name: 'Prévision 00-05',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 1,
      date: vue.$moment().format(),
    },
    {
      id: '83',
      logicalId: 'prev1',
      name: 'Prévision 05-10',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 1,
      date: vue.$moment().format(),
    },
    {
      id: '84',
      logicalId: 'prev2',
      name: 'Prévision 10-15',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 1,
      date: vue.$moment().format(),
    },
    {
      id: '85',
      logicalId: 'prev3',
      name: 'Prévision 15-20',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 1,
      date: vue.$moment().format(),
    },
    {
      id: '86',
      logicalId: 'prev4',
      name: 'Prévision 20-25',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 1,
      date: vue.$moment().format(),
    },
    {
      id: '87',
      logicalId: 'prev5',
      name: 'Prévision 25-30',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 1,
      date: vue.$moment().format(),
    },
    {
      id: '88',
      logicalId: 'prev6',
      name: 'Prévision 30-35',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 1,
      date: vue.$moment().format(),
    },
    {
      id: '89',
      logicalId: 'prev7',
      name: 'Prévision 35-40',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 1,
      date: vue.$moment().format(),
    },
    {
      id: '90',
      logicalId: 'prev8',
      name: 'Prévision 40-45',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 1,
      date: vue.$moment().format(),
    },
    {
      id: '91',
      logicalId: 'prev9',
      name: 'Prévision 45-50',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 2,
      date: vue.$moment().format(),
    },
    {
      id: '92',
      logicalId: 'prev10',
      name: 'Prévision 50-55',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 3,
      date: vue.$moment().format(),
    },
    {
      id: '93',
      logicalId: 'prev11',
      name: 'Prévision 55-60',
      eqId: '40',
      module: 'rain',
      type: 'numeric',
      isVisible: true,
      currentValue: 1,
      date: vue.$moment().format(),
    },

    {
      id: '100',
      logicalId: '10/4/111',
      name: 'Intensité',
      eqId: '101',
      module: 'knx',
      type: 'numeric',
      genericType: 'LIGHT_STATE',
      isVisible: true,
      currentValue: 0,
      date: vue.$moment().subtract(1, 'day').format(),
    },
    {
      id: '101',
      logicalId: '24/4/25',
      name: 'État',
      eqId: '20',
      module: 'knx',
      type: 'boolean',
      genericType: 'LIGHT_STATE',
      isVisible: true,
      currentValue: 0,
      date: vue.$moment().subtract(1, 'day').format(),
    },
    {
      id: '170',
      logicalId: '10/4/108',
      name: 'État',
      eqId: '17',
      module: 'knx',
      type: 'boolean',
      genericType: 'LIGHT_STATE',
      isVisible: true,
      currentValue: 0,
      date: vue.$moment().subtract(1, 'day').format(),
    },
    {
      id: '200',
      logicalId: 'download',
      name: 'Download',
      eqId: '10',
      module: 'box',
      type: 'numeric',
      genericType: 'DOWNLOAD',
      isVisible: true,
      currentValue: 62,
      unit: 'KB/s',
      date: vue.$moment().subtract(3, 'minutes').format(),
    },
    {
      id: '201',
      logicalId: 'upload',
      name: 'Upload',
      eqId: '10',
      module: 'box',
      type: 'numeric',
      genericType: 'UPLOAD',
      isVisible: true,
      currentValue: 6,
      unit: 'KB/s',
      date: vue.$moment().subtract(3, 'minutes').format(),
    },
    { id: '176', isVisible: false, name: 'Prochaine pluie', module: 'rain', type: 'datetime', logicalId: 'nextRainDate', eqId: '40', date: vue.$moment().format(), currentValue: vue.$moment().add(35, 'minutes').format() },
  ],
  userViews: [
    { isActive: true, cards: [{ type: 'custom', elements: [{ type: 'state', id: '5', parentId: '3', label: 'Extérieur' }, { type: 'state', id: '16', parentId: '8', label: 'Salon' }, { type: 'state', id: '11', parentId: '4', label: 'Chambre' }], title: 'Températures' }, { type: 'equipment', id: '40' }, { type: 'custom', elements: [{ type: 'state', id: '6', parentId: '3', label: 'Extérieur' }, { type: 'state', id: '15', parentId: '8', label: 'Salon' }, { type: 'state', id: '14', parentId: '4', label: 'Chambre' }], title: 'Humidité' }], id: '1', code: 'weather', title: 'Météo', icon: 'fas fa-cloud-sun-rain', isShared: true },
    { isActive: true, cards: [{ type: 'custom', elements: [{ type: 'state', id: '101', parentId: '20', label: 'Chambre' }, { type: 'state', id: '170', parentId: '17', label: 'Cuisine' }, { type: 'state', id: '100', parentId: '101', label: 'Séjour' }], title: 'Lumières' }], code: 'lights', title: 'Lumières', icon: 'far fa-lightbulb', isShared: true, id: '2' },
  ],
  scenarios: [
    { id: '1', isVisible: false, isActive: true, triggers: [{ type: 'state', value: '5' }], elements: [{ type: 'rule', definition: { type: 'any', criterias: [{ fact: '5', operator: 'lte', value: 0 }], onValidElements: [{ type: 'action', definition: { id: '5', paramsType: 'jsonata', params: "'Risque de gel, la température extérieure est de '&_5&'°C'" }, isActive: true }], onInvalidElements: [], skipRepeated: true }, isActive: true }], name: 'Alerte gel', lastExecution: vue.$moment().subtract(1, 'days').format() },
    { id: '2', isVisible: false, isActive: true, triggers: [{ type: 'datetime', value: '0 0 8 * * *' }], elements: [{ type: 'rule', definition: { type: 'any', criterias: [{ fact: '1', operator: 'e', value: '0' }], onValidElements: [{ type: 'action', definition: { id: '105', paramsType: 'string', params: null }, isActive: true }, { type: 'action', definition: { id: '108', paramsType: 'string', params: null }, isActive: true }, { type: 'action', definition: { id: '102', paramsType: 'string', params: null }, isActive: true }], onInvalidElements: [] }, isActive: true }], name: 'Ouverture automatique des volets' },
    { id: '3', isVisible: true, isActive: true, triggers: [], elements: [{ type: 'action', definition: { id: '105', paramsType: 'string', params: null }, isActive: true }, { type: 'action', definition: { id: '108', paramsType: 'string', params: null }, isActive: true }, { type: 'action', definition: { id: '102', paramsType: 'string', params: null }, isActive: true }], name: 'Ouverture de tous les volets', description: 'Ouverture manuelle de tous les volets' },
  ],
  channels: [
    { id: '2', name: 'XMPP', input: '17', output: '5', isActive: true, logicalId: '12345678', module: 'xmpp' },
  ],
  jobs: [
    {
      id: 'system-communication-check',
      name: '[System] Vérification de la communication des équipements',
      isRunning: true,
      cronTime: '0 */15 * * * *',
      lastDate: vue.$moment().subtract(2, 'minutes').format(),
      nextDate: vue.$moment().add(13, 'minutes').format(),
    },
  ],
  queries: [
    { query: 'La porte est-elle fermée', reply: 'La porte est fermée' },
    { query: "L'alarme est-elle enclenchée", reply: "L'alarme est enclenchée" },
    { query: 'Quelle est la température du salon', reply: 'Il fait 22°C dans le salon' },
    { query: 'Quelle est la température de la chambre', reply: 'Il fait 21°C dans la chambre' },
    { query: 'Va-t-il pleuvoir', reply: "Voici les pr\u00e9visions de pluie :\\n\\nActuellement : 0 mm/h.\\nD'ici 1 heure : Pas de pr\u00e9cipitations." },
  ],
  intents: [
    { id: '1', utterances: [], answers: [{ template: "Désolé {{from}}, je n'ai pas compris", opts: 'from !== undefined' }, { template: "Désolé, je n'ai pas compris", opts: 'from === undefined' }, { template: 'Pardon {{from}}, mais je ne comprends pas', opts: 'from !== undefined' }, { template: 'Pardon, mais je ne comprends pas', opts: 'from === undefined' }], actions: [], key: 'None', description: 'Messages par défaut', isActive: true },
    { id: '7', utterances: [{ value: 'Va t il pleuvoir ?' }, { value: "Pluie dans l'heure" }, { value: 'Pluie' }, { value: 'Dois-je prendre un parapluie ?' }], answers: [{ template: '{{nextRaindate}}.', opts: '' }], actions: [{ key: 'getStateValueJsonata', parameters: [{ value: '176' }, { value: "$ ? \"Il pourrait pleuvoir dans \" & $floor(($toMillis()-$millis())/60000) & \" minutes\": \"Pas de pluie prévue dans l'heure\"" }, { value: 'nextRaindate' }] }, { key: 'bindContext', parameters: [] }], key: 'weather.rain', description: 'Prévision de pluie', isActive: true },
  ],
  entities: [],
  notifications: [{
    id: '1',
    date: vue.$moment().subtract(532, 'minutes').format(),
    plugin: 'netatmo',
    message: 'Erreur lors de la récupération des données',
    action: '',
  },
  {
    id: '2',
    date: vue.$moment().subtract(150, 'minutes').format(),
    plugin: 'scenario',
    message: 'Le scénario a rencontré une erreur',
    action: '',
  },
  ],
  logs: [
    {
      message: '[WS] Utilisateur "demo" authentifié (IP: 10.0.0.53)',
      level: 'info',
      service: 'core',
      timestamp: vue.$moment().format(),
    },
    {
      message: 'Lancement du scénario #1',
      level: 'debug',
      service: 'core',
      timestamp: vue.$moment().subtract(42, 'minutes').format(),
    },
    { method: 'POST', url: '/api/views', statusCode: 400, code: 'InputValidationError', message: '[API] Ressource invalide : body/cards ne doit pas contenir moins de 1 élément', detail: [{ keyword: 'minItems', dataPath: '.cards', schemaPath: '#/properties/cards/minItems', params: { limit: 1 }, message: 'ne doit pas contenir moins de 1 élément' }], stack: 'Error: Ressource invalide : body/cards ne doit pas contenir moins de 1 élément\n    at Object.<anonymous> (/home/node/app/api/index.js:72:13)\n    at handleError (/home/node/app/node_modules/fastify/lib/reply.js:555:20)\n    at onErrorHook (/home/node/app/node_modules/fastify/lib/reply.js:524:5)\n    at _Reply.Reply.send (/home/node/app/node_modules/fastify/lib/reply.js:128:5)\n    at preValidationCallback (/home/node/app/node_modules/fastify/lib/handleRequest.js:85:11)\n    at handleReject (/home/node/app/node_modules/fastify/lib/hooks.js:184:5)\n    at runMicrotasks (<anonymous>)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)', level: 'error', service: 'core', timestamp: vue.$moment().subtract(73, 'minutes').format() },
  ],
  loggersLevel: [
    { logger: 'core', level: 'debug' },
  ],
}

// mock functions
function getAll (collection) {
  return cloneDeep(mock[collection])
}

function get (collection, query) {
  const data = cloneDeep(mock[collection]
    .filter((item) => {
      let match = true
      for (const field in query) {
        if (item[field] !== query[field]) {
          match = false
        }
      }
      return match
    }))
  return data
}

function getById (collection, id) {
  const data = cloneDeep(mock[collection].find((item) => item.id === id))
  return data
}

function add (collection, item) {
  item.id = (Math.max.apply(Math, mock[collection].map((item) => parseInt(item.id))) + 1).toString()
  mock[collection].push(item)
  return cloneDeep(item)
}

function update (collection, updatedItem) {
  mock[collection].forEach((item) => {
    if (item.id === updatedItem.id) {
      item = Object.assign(item, updatedItem)
    }
  })
  return cloneDeep(updatedItem)
}

function remove (collection, id) {
  const index = mock[collection].findIndex((item) => item.id === id)
  mock[collection].splice(index, 1)
}

function getEvents () {
  const value = Math.floor(1250 * (0.9 + Math.random() / 4))
  return [
    { type: 'stateUpdate', payload: { id: '4', currentValue: value, date: vue.$moment().format(), eqId: '2' } },
    { type: 'equipmentUpdate', payload: { id: '2', roomId: '1', lastCommunication: vue.$moment().format() } },
    { type: 'roomSummaryUpdate', payload: { id: '1', key: 'power', value } },
    { type: 'roomSummaryUpdate', payload: { id: 'global', key: 'power', value } },
  ]
}

// mock API
const DemoApi = function (Vue, store = null, statisticsPeriod = 86400000) {
  let accessToken = null
  let timerId = null

  function handleEventsResponse (event) {
    const updateStates = []
    switch (event.type) {
      case 'roomSummaryUpdate': {
        event.payload.key = event.payload.key.toLowerCase()
        store.commit('data/saveRoomSummary', event.payload)
        break
      }
      case 'equipmentUpdate': {
        store.commit('data/updateEquipments', [event.payload])
        break
      }
      case 'stateUpdate': {
        updateStates.push({
          id: event.payload.id,
          currentValue: event.payload.currentValue,
          date: event.payload.date,
          eqId: event.payload.eqId,
        })
        break
      }
    }
    if (updateStates.length > 0) {
      store.commit('data/updateStates', updateStates)
    }
  }

  return {

    // request user API key from his credentials
    authenticate (username, password) {
      // return authentication (token JWT)
      return {
        access_token: 'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxIiwibmFtZSI6ImRlbW8iLCJzY29wZSI6ImFkbWluIHdyaXRlIiwiaWF0IjoxNjEwOTMxMzM5LCJleHAiOjE5MzY4NTEzMzksImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3QifQ.sign',
      }
    },

    // initialize authentication (token JWT)
    setAuthentication (_token) {
      accessToken = _token.access_token
      return _token
    },

    // logout
    logout () {
    },

    // return all roles
    getAllRoles () {
      return ['admin', 'write', 'system']
    },

    // return user roles
    getRoles (authentication) {
      const roles = ['user']
      if (authentication.access_token) {
        try {
          const payload = JSON.parse(atob(authentication.access_token.split('.')[1]))
          roles.push(...payload.scope.split(' '))
        } catch (error) {
          console.warn('JWT parsing failed', error)
        }
      }
      return roles
    },

    // return user identifier
    getUserId (authentication) {
      if (authentication.access_token) {
        try {
          const payload = JSON.parse(atob(authentication.access_token.split('.')[1]))
          return payload.sub
        } catch (error) {
          console.warn('JWT parsing failed', error)
          return undefined
        }
      }
    },

    // suscribe to Jeedom events throught websocket
    openEventsListener (resetCounter, forceRefresh = false) {
      if (!store.state.app.hasNetwork) {
        // no network
      }
      if (!accessToken) {
        console.warn('Missing API key')
        store.commit('app/setInformation', { type: 'is-danger', message: 'Erreur d\'authentification, veuillez-vous reconnecter' })
        store.commit('app/setUser', { login: null, isAuthenticated: false })
        return
      }
      // ensure only one socket
      if (timerId) {
        console.warn('Socket already opened')
        return
      }
      timerId = setInterval(function () {
        getEvents().forEach(handleEventsResponse)
      }, 30000)
      store.commit('app/setEventsListenerStatus', true)
    },

    // close websocket connection
    closeEventsListener () {
      if (timerId) {
        clearInterval(timerId)
        timerId = null
        store.commit('app/setEventsListenerStatus', false)
      }
    },

    // request all rooms and returns only visible ones
    async getRooms (isIncludingEquipments, isIncludingSummary) {
      const rooms = getAll('rooms')
      if (isIncludingEquipments) {
        rooms.forEach((room) => {
          const equipments = get('equipments', { roomId: room.id })
          equipments.forEach((equipment) => {
            equipment.states = get('states', { eqId: equipment.id })
            equipment.actions = get('actions', { eqId: equipment.id })
          })
          room.equipments = equipments
        })
      }
      return rooms
    },

    // request room
    async getRoom (roomId, isIncludingSummaryStates) {
      const room = getById('rooms', roomId)
      const equipments = get('equipments', { roomId: room.id })
      room.equipments = equipments
      if (!isIncludingSummaryStates) {
        delete room.summaryStates
      }
      return room
    },

    // create/update room
    async createRoom (room) {
      return add('rooms', room)
    },

    // create/update room
    async updateRoom (room) {
      return update('rooms', room)
    },

    // create/update room
    async deleteRoom (roomId) {
      remove('rooms', roomId)
    },

    // request global summary
    async getSummary () {
      const summary = {}
      getById('rooms', '1').summary.forEach((item) => {
        summary[item.key] = item.value
      })
      return summary
    },

    // request key room summary
    async getRoomSummary (roomId, key) {
      return {}
    },

    // request all equipments
    async getEquipments (isIncludingActions, isIncludingStates) {
      const equipments = getAll('equipments')
      equipments.forEach((equipment) => {
        if (isIncludingActions) {
          equipment.actions = get('actions', { eqId: equipment.id })
        }
        if (isIncludingStates) {
          equipment.states = get('states', { eqId: equipment.id })
        }
      })
      return equipments
    },

    // request equipment
    async getEquipment (equipmentId) {
      const equipment = getById('equipments', equipmentId)
      equipment.states = get('states', { eqId: equipment.id })
      equipment.actions = get('actions', { eqId: equipment.id })
      return equipment
    },

    // create equipment
    async createEquipment (equipment) {
      return add('equipments', equipment)
    },

    // update equipment
    async updateEquipment (equipment) {
      return update('equipments', equipment)
    },

    // delete equipment
    async deleteEquipment (equipmentId) {
      remove('equipments', equipmentId)
    },

    // request all states
    async getStates () {
      return getAll('states')
    },

    // request state
    async getState (stateId) {
      return getById('states', stateId)
    },

    // create state
    async createState (state) {
      return add('states', state)
    },

    // update state
    async updateState (state) {
      return update('states', state)
    },

    // delete state
    async deleteState (stateId) {
      remove('states', stateId)
    },

    // request all actions
    async getActions () {
      return getAll('actions')
    },

    // request action
    async getAction (actionId) {
      return getById('actions', actionId)
    },

    // create action
    async createAction (action) {
      return add('actions', action)
    },

    // update action
    async updateAction (action) {
      return update('actions', action)
    },

    // delete action
    async deleteAction (actionId) {
      remove('actions', actionId)
    },

    // request all users
    async getUsers () {
      return getAll('users')
    },

    // request user
    async getUser (userId) {
      const user = getById('users', userId)
      if (!user) {
        throw new Error('unkwnow')
      }
      return user
    },

    // create user
    async createUser (user) {
      user.roles = []
      user.isActive = false
      return add('users', user)
    },

    // update user
    async updateUser (user) {
      return update('users', user)
    },

    // update user
    updateUserPassword (id, password) {
      return 1
    },

    // delete user
    async deleteUser (userId) {
      remove('users', userId)
    },

    // get user tokens
    async getUserTokens (userId) {
      return getAll('tokens')
    },

    // get user tokens
    async deleteUserToken (userId, tokenId) {
      remove('tokens', tokenId)
    },

    // create an user token
    async requestUserRefreshToken (userId) {
      const token = {
        userId,
        issuedDate: vue.$moment().format(),
        userAgent: 'Mozilla/5.0 (Android 9; Mobile; rv:84.0) Gecko/84.0 Firefox/84.0',
        ip: '10.0.0.99',
        token: `abcd1234-${Math.floor(999 * Math.random()).toString().padStart(4, 0)}-1234-abcd-a${Math.floor(9999999999 * Math.random()).toString().padStart(10, 0)}d`,
      }
      return add('tokens', token)
    },

    // request current user profile
    async getMyProfile () {
      return getById('users', '1')
    },

    // update current user profile
    async updateMyProfile (user) {
      return update('users', user)
    },

    // update current user password
    async updateMyPassword (password) {
    },

    // get user tokens
    async getMyTokens () {
      return get('tokens', { userId: '1' })
    },

    // get current user tokens
    async deleteMyToken (tokenId) {
      remove('tokens', tokenId)
    },

    // execute a command
    async executeAction (actionId, params = {}) {
      const action = getById('actions', actionId)
      if (action.stateFeedbackId) {
        if (params) {
          if (Object.prototype.hasOwnProperty.call(params, 'slider')) {
            params.value = params.slider
            delete params.slider
          }
          if (Object.prototype.hasOwnProperty.call(params, 'select')) {
            params.value = params.select
            delete params.select
          }
          action.params = Object.assign(action.params, params)
        }

        const state = getById('states', action.stateFeedbackId)
        state.currentValue = action.params.value
        state.date = Vue.moment().format()
        update('states', state)
        handleEventsResponse({ type: 'stateUpdate', payload: state })

        const equipment = getById('equipments', state.eqId)
        equipment.lastCommunication = state.date
        update('equipments', equipment)
        handleEventsResponse({ type: 'equipmentUpdate', payload: equipment })
        return
      }
      const equipment = getById('equipments', action.eqId)
      equipment.lastCommunication = Vue.moment().format()
      update('equipments', equipment)
      handleEventsResponse({ type: 'equipmentUpdate', payload: equipment })
    },

    // request all scenarios
    async getScenarios () {
      return getAll('scenarios')
        .map((scenario) => {
          scenario.state = 'stop'
          return scenario
        })
    },

    // change scenario state (run, stop, enable, disable)
    async changeScenarioState (id, status) {
      return true
    },

    // request scenario
    async getScenario (scenarioId) {
      return getById('scenarios', scenarioId)
    },

    // create scenario
    async createScenario (scenario) {
      return add('scenarios', scenario)
    },

    // create or update scenario
    async updateScenario (scenario) {
      return update('scenarios', scenario)
    },

    async deleteScenario (scenarioId) {
      return remove('scenarios', scenarioId)
    },

    // request all intents
    async getIntents () {
      return getAll('intents')
    },

    // request intent
    async getIntent (intentId) {
      return getById('intents', intentId)
    },

    // create intent
    async createIntent (_intent) {
      return add('intents', _intent)
    },

    // create or update intent
    async updateIntent (_intent) {
      return update('intents', _intent)
    },

    async deleteIntent (intentId) {
      return remove('intents', intentId)
    },

    // request intent actions for options in select
    async getIntentActions () {
      return [
        { value: 'getSummary', label: 'Lire un résumé', parametersPlaceholder: ['Clé de l\'entité', 'Clé du résumé'] },
        { value: 'getEquipmentStateValue', label: 'Lire l\'état d\'un équipement', parametersPlaceholder: ['Clé de l\'entité'] },
        { value: 'getStateValueJsonata', label: 'Lire une opération JSONata sur un état', parametersPlaceholder: ['Identifiant état', 'JSONata expression', 'Clé d\'écriture dans le contexte'] },
        { value: 'executeAction', label: 'Exécuter une action', parametersPlaceholder: ['Identifiant de l\'action', 'Paramètre de l\'action'] },
        { value: 'bindContext', label: 'Fusionner les variables', parametersPlaceholder: [] },
      ]
    },

    // request all entities
    async getEntities () {
      return getAll('entities')
    },

    // request entity
    async getEntity (entityId) {
      return getById('entities', entityId)
    },

    // create intent
    async createEntity (_entity) {
      return add('entities', _entity)
    },

    // create or update intent
    async updateEntity (_entity) {
      return update('entities', _entity)
    },

    async deleteEntity (entityId) {
      return remove('entities', entityId)
    },

    async trainNlp () {
    },

    async processNlp (utterance) {
      return { locale: 'fr', utterance: 'test', channel: 'admin-test-nlp', from: 'user', languageGuessed: false, localeIso2: 'fr', language: 'French', nluAnswer: { classifications: [{ intent: 'weather.rain', score: 0 }] }, classifications: [{ intent: 'weather.rain', score: 0 }], intent: 'None', score: 1, domain: 'default', sourceEntities: [], entities: [], answers: [{ answer: "Désolé utilisateur, je n'ai pas compris", opts: 'from !== undefined' }, { answer: 'Pardon utilisateur, mais je ne comprends pas', opts: 'from !== undefined' }], answer: 'Pardon utilisateur, mais je ne comprends pas', actions: [], duration: 262 }
    },

    // request all channels
    async getChannels () {
      return getAll('channels')
    },

    // request channel
    async getChannel (channelId) {
      return getById('channels', channelId)
    },

    // create channel
    async createChannel (channel) {
      return add('channels', channel)
    },

    // update channel
    async updateChannel (channel) {
      return update('channels', channel)
    },

    // delete channel
    async deleteChannel (channelId) {
      return remove('channels', channelId)
    },

    // request cmd statistics and return min, max and average
    async getStatistics (stateId, from = null, until = null) {
      const state = getById('states', stateId)
      const trends = [-1, 0, 0, 0, 1]
      return {
        min: Number.parseFloat(Number.parseFloat(state.currentValue * (1 - Math.random())).toPrecision(3)),
        avg: Number.parseFloat(Number.parseFloat(state.currentValue * (0.5 + Math.random())).toPrecision(3)),
        max: Number.parseFloat(Number.parseFloat(state.currentValue * (1 + Math.random())).toPrecision(3)),
        trend: trends[Math.floor(Math.random() * trends.length)],
      }
    },

    // request state history
    async getHistory (stateId, from = null, until = null) {
      const state = getById('states', stateId)
      const result = []
      for (let index = 0; index < 48; index++) {
        result.push({
          value: state.currentValue * (0.5 + Math.random()),
          date: Vue.moment().subtract(index * 30, 'minutes'),
        })
      }
      return result
    },

    // request all user views
    async getUserViews () {
      return getAll('userViews')
    },

    // request user view
    async getUserView (viewId) {
      return getById('userViews', viewId)
    },

    // create user view
    async createUserView (userView) {
      return add('userViews', userView)
    },

    // update user view
    async updateUserView (userView) {
      return update('userViews', userView)
    },

    // delete user view
    async deleteUserView (viewId) {
    },

    // request logs
    async getLogs (query = null) {
      return getAll('logs')
    },

    async getLoggersLevel () {
      return getAll('loggersLevel')
    },

    async setLoggerLevel (loggerLevel) {
      return update('loggersLevel', loggerLevel)
    },

    // request jobs
    async getJobs (query = null) {
      return getAll('jobs')
    },

    // request jobs
    async restartJobs (query = null) {
      return getAll('jobs')
    },

    async getDatabaseCollections () {
      return [{ name: 'states', stats: { size: 127682, count: 206, avgObjSize: 619, storageSize: 110592, totalIndexSize: 73728 } }, { name: 'users', stats: { size: 595, count: 3, avgObjSize: 198, storageSize: 36864, totalIndexSize: 73728 } }, { name: 'counters', stats: { size: 650, count: 12, avgObjSize: 54, storageSize: 36864, totalIndexSize: 73728 } }, { name: 'logs', stats: { size: 29590116, count: 67850, avgObjSize: 436, storageSize: 8376320, totalIndexSize: 2019328 } }, { name: 'equipments', stats: { size: 11358, count: 59, avgObjSize: 192, storageSize: 36864, totalIndexSize: 73728 } }, { name: 'rooms', stats: { size: 3107, count: 17, avgObjSize: 182, storageSize: 36864, totalIndexSize: 32768 } }, { name: 'usersTokens', stats: { size: 2162, count: 11, avgObjSize: 196, storageSize: 36864, totalIndexSize: 36864 } }, { name: 'statesHistory', stats: { size: 21639889, count: 341838, avgObjSize: 63, storageSize: 7192576, totalIndexSize: 12488704 } }, { name: 'userViews', stats: { size: 592, count: 1, avgObjSize: 592, storageSize: 36864, totalIndexSize: 20480 } }, { name: 'channels', stats: { size: 260, count: 2, avgObjSize: 130, storageSize: 36864, totalIndexSize: 110592 } }, { name: 'intents', stats: { size: 7083, count: 12, avgObjSize: 590, storageSize: 36864, totalIndexSize: 73728 } }, { name: 'scenarios', stats: { size: 9022, count: 13, avgObjSize: 694, storageSize: 36864, totalIndexSize: 36864 } }, { name: 'entities', stats: { size: 133, count: 1, avgObjSize: 133, storageSize: 20480, totalIndexSize: 40960 } }, { name: 'actions', stats: { size: 16867, count: 80, avgObjSize: 210, storageSize: 45056, totalIndexSize: 36864 } }]
    },

    async getDatabaseBackup (_params) {
      throw new Error('Non géré sur la démo')
    },

    async importDatabaseBackup (file) {
      throw new Error('Non géré sur la démo')
    },

    async getSystemMetrics () {
      return { load: [{ period: '1 minute', value: 0.39 }, { period: '5 minutes', value: 0.26 }, { period: '15 minutes', value: 0.19 }], cpuCores: 4, disk: [{ fs: '/dev/sda2', mount: '/', size: 240032280, available: 210612040 }, { fs: '/dev/sda1', mount: '/boot/firmware', size: 258095, available: 129241 }], memory: { memTotal: 1890052, memFree: 192048, memAvailable: 514796, swapTotal: 0, swapFree: 0 }, containers: [{ name: 'domonode_log.1.6q5kpqortbqayhgv5ndrzgtpx', memory: { raw: '38.54MiB / 150MiB', percent: 25.69, usage: 40412119.04, size: 157286400 }, cpu: 0 }, { name: 'domonode_redis.1.3nazmwogexhrl9h1fraz1mwld', memory: { raw: '4.773MiB / 50MiB', percent: 9.55, usage: 5004853.248, size: 52428800 }, cpu: 0.38 }, { name: 'domonode_nlp.1.37awa5t3qf6rh69q6vszc3cln', memory: { raw: '96.79MiB / 200MiB', percent: 48.39, usage: 101491671.04, size: 209715200 }, cpu: 0 }, { name: 'domonode_core.1.i57lycvfaf0os73uxvj0ac3a8', memory: { raw: '100.9MiB / 150MiB', percent: 67.28, usage: 105801318.4, size: 157286400 }, cpu: 0 }, { name: 'domonode_vue-dom.1.qgn4i47awewl50tium41e8o1y', memory: { raw: '4.102MiB / 20MiB', percent: 20.51, usage: 4301258.752, size: 20971520 }, cpu: 0 }, { name: 'domonode_node-red.1.pbafyahjq3tezh17netn1sns6', memory: { raw: '144.3MiB / 200MiB', percent: 72.17, usage: 151309516.8, size: 209715200 }, cpu: 0 }, { name: 'domonode_haproxy.1.hwwcbjyvhwzin30nfyrs0dn78', memory: { raw: '22.03MiB / 50MiB', percent: 44.05, usage: 23100129.28, size: 52428800 }, cpu: 0.29 }, { name: 'domonode_mongo.1.6buw1phdymtn1jzvurwjz620k', memory: { raw: '194.4MiB / 250MiB', percent: 77.77, usage: 203843174.4, size: 262144000 }, cpu: 2.31 }], date: vue.$moment().subtract(3, 'minutes').format() }
    },

    async getSystemHealth () {
      return {
        healthy: true,
        components: [
          { key: 'db', label: 'Base de données', status: 'ok' },
          { key: 'events', label: 'Évenements (Pub/Sub)', status: 'ok' },
        ],
      }
    },

    // try to ask a question
    async askQuestion (query, replyCmd = null) {
      const result = get('queries', { query })
      if (result.length > 0) {
        return result[0].reply
      } else {
        const replies = ['Désolé, je n\'ai pas compris la demande', 'Je ne comprends pas', 'Je ne sais pas traiter cette requête :(']
        return replies[Math.floor(Math.random() * replies.length)]
      }
    },

    // request defined interactions
    async getSentences () {
      return getAll('queries').map((query) => query.query)
    },

    // request system notifications
    async getNotifications () {
      return getAll('notifications')
    },

    // delete system notifications
    async clearNotifications () {
      getAll('notifications').forEach((notification) => remove('notifications', notification.id))
    },
  }
}

export { DemoApi }
